import doLineSegmentsIntersect from './line_segments_intersect'
import mapConverters from './map_converters'
import mapEvents from './map_events'

export const defaultShapeOptions = {
  strokeColor: '#0077d9',
  fillColor: '#0077d9',
  fillOpacity: 0.1,
  clickable: false
};

export default class DrawingManager {

  constructor(googleMap) {
    this.drawings = [];
    this.googleMap = googleMap;
    
    this._drawingInProgress = false;
    this._drawingsVisible = true;
  }

  hasDrawings() {
    return this.drawings.length > 0;
  }

  drawingsVisible() {
    return this._drawingsVisible;
  }

  add(shape) {
    shape.visible = this._drawingsVisible;
    this.drawings.push(shape);
    shape.setMap(this.googleMap);
  }

  toggleVisibility(visible) {
    var self = this;    
    var oldDrawings = this.drawings;
    this.deleteAll();

    oldDrawings.forEach((drawing) => {
      drawing.visible = visible;
      self.drawings.push(drawing);
      drawing.setMap(self.googleMap);
    });
    this._drawingsVisible = visible;
  }

  deleteAll() {
    if(this.drawings.length > 0) {
      this.drawings.forEach(function(drawing){
        drawing.setMap(null);
      });
      this.drawings = [];
    }
  }


  drawingInProgress() {
    return this._drawingInProgress;
  }

  startDrawing() {
    this._drawingInProgress = true;

    // We are only making the polygon editable so that the handle will appear
    // after the first click. Otherwise, the user doesn't get any feedback
    // that their click has added a point. Editing is turned of in the
    // polygoncomplete handler.
    let polygonOptions = $.extend({}, defaultShapeOptions, {editable: true});

    if(typeof this.googleDrawingManager === 'undefined'){
      this.googleDrawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: false,
        polygonOptions: polygonOptions
      });
    }

    if(typeof this._polygonCompleteListener === 'undefined') {
      this._polygonCompleteListener = google.maps.event.addListener(
        this.googleDrawingManager, 
        'polygoncomplete', 
        this._polygonCompleteHandler.bind(this)
      );
    }

    this.googleDrawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
    this.googleDrawingManager.setMap(this.googleMap);
  }

  cancelDrawing() {
    google.maps.event.removeListener(this._polygonCompleteListener);
    delete this._polygonCompleteListener;

    this._drawingInProgress = false;
    // erase an incomplete drawing
    this.googleDrawingManager.setMap(null);
    // exit drawing mode
    this.googleDrawingManager.setDrawingMode(null);
    window.dispatchEvent(mapEvents.drawingComplete());
  }

  _polygonCompleteHandler(polygon) {
    var pointsArray = polygon.getPath();

    if(this._validatePath(pointsArray)){
      this._drawingInProgress = false;

      polygon.setEditable(false);
      this.add(polygon);

      this.googleDrawingManager.setDrawingMode(null);

      window.dispatchEvent(mapEvents.drawingComplete(polygon));
    } else {
      polygon.setMap(null);
      window.dispatchEvent(mapEvents.drawingError());
    }
    
  }

  _validatePath(googlePointsArray){

    if(googlePointsArray.length < 3){
      return false;
    }

    var pointsArray = mapConverters.googlePointsToXYPoints(googlePointsArray);

    for (var i=0; i < (pointsArray.length - 1); i++) {

      var a = pointsArray[i];
      var b = pointsArray[i+1];

      for (var j=i; j < (pointsArray.length - 2); j++) {
        var c = pointsArray[j+2];
        var d;
        if (j+3 < pointsArray.length){
          d = pointsArray[j+3];
        } else if (i !== 0 ) {
          d = pointsArray[0];
        } else {
          continue;
        }

        if(doLineSegmentsIntersect(a, b, c, d)) {
          return false;
        }

      }
    }

    return true;
  }

}
